module.exports = __webpack_public_path__ + "static/media/empty_Transparent@2x.c6023255.png";